import { ROUTE_PATH } from './route-paths';
import { Switch } from 'react-router-dom';
// Page Imports

// These could be added to the containers index
import { Redirect, Route } from 'react-router';
import { SetPassword } from '../containers/onboarding/set-password';
import { ProfileStep } from '../containers/onboarding/profile-step';
import { TopicPreferencesOnboarding } from '../containers/onboarding/topic-preferences';
import { SMSCodeAuthentication } from '../containers/onboarding/sms-code-authentication';

export const OnboardingRouter = () => {
  const onboardingComponent = () => <Redirect to={ROUTE_PATH.ONBOARDING_SET_PASSWORD} />;

  const onboardingRoutes = [
    {
      path: ROUTE_PATH.ONBOARDING,
      component: onboardingComponent,
    },
    {
      path: ROUTE_PATH.ONBOARDING_SET_PASSWORD,
      component: SetPassword,
    },
    {
      path: ROUTE_PATH.ONBOARDING_PROFILE,
      component: ProfileStep,
    },
    {
      path: ROUTE_PATH.ONBOARDING_PHONE_VERIFICATION,
      component: SMSCodeAuthentication,
    },
    {
      path: ROUTE_PATH.ONBOARDING_TOPIC_PREFERENCES,
      component: TopicPreferencesOnboarding,
    },
  ];

  return (
    <Switch>
      {onboardingRoutes.map(({ path, component }) => (
        <Route key={path} exact path={path} component={component} />
      ))}
      <Route exact path="*" render={() => <Redirect to={ROUTE_PATH.ONBOARDING} />} />
    </Switch>
  );
};
